import { FilterTypes } from 'Core/interfaces'

import { UrlParams } from 'Portals/Customer/constants'
import { ServiceLocation, ServiceLocationFilterFields } from 'Portals/Customer/entities'
import i18n from 'Portals/Customer/utils/i18nService'

export const getFiltersConfig = (): ServiceLocation.Filter.Config => ({
	[ServiceLocationFilterFields.serviceLocationId]: {
		label: `${i18n.t('pages:serviceLocation.filters.serviceLocation')}:`,
		apiFilterFieldName: ServiceLocationFilterFields.serviceLocationId,
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.serviceLocationId,
		defaultValue: ''
	},
	[ServiceLocationFilterFields.billingLocationId]: {
		label: `${i18n.t('pages:serviceLocation.filters.billingLocation')}:`,
		apiFilterFieldName: ServiceLocationFilterFields.billingLocationId,
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.billingLocationId,
		defaultValue: ''
	},
	[ServiceLocationFilterFields.programManagerId]: {
		label: `${i18n.t('pages:serviceLocation.filters.programManager')}:`,
		apiFilterFieldName: ServiceLocationFilterFields.programManagerId,
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.programManagerId,
		defaultValue: ''
	}
})
